import moment from "moment";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onUserBalance } from "../../../redux/homeAction";

const BetModel = ({
                    userBetsGame,
                    matchData,
                    setTeamId,
                    setAmount,
                    amount,
                    teamId,
                  }) => {
  const dispatch = useDispatch();
  const [time, setTime] = useState(() => new Date().getTime());
  const [possibleGain, setPossibleGain] = useState(0);
  const getUserBalance = useSelector((state) => state.home.getUserBalance);

  const userDetails = useMemo(
      () => JSON.parse(localStorage.getItem("userDetails")),
      []
  );

  useEffect(() => {
    if (userDetails?.user_id) {
      const data = { user_id: userDetails.user_id };
      dispatch(onUserBalance(data));
    }
  }, [dispatch, userDetails]);

  useEffect(() => {
    if (matchData.start_date) {
      const latestDate = moment(
          matchData.start_date,
          "YYYY-MM-DD hh:mm:ss A"
      ).format("YYYY-MM-DDTHH:mm:ss");
      const checkInTime = new Date(latestDate).getTime();
      const interValTime = setInterval(() => {
        setTime(checkInTime - new Date().getTime());
      }, 1000);

      return () => {
        clearInterval(interValTime);
      };
    }
  }, [matchData]);

  useEffect(() => {
    const modal = document.getElementById('betHere');
    const handleModalShow = () => {
      setTeamId(null);
      setAmount('');
      setPossibleGain(0);
    };
    
    modal?.addEventListener('show.bs.modal', handleModalShow);
    return () => {
      modal?.removeEventListener('show.bs.modal', handleModalShow);
    };
  }, [setTeamId, setAmount]);

  const verifyAmount = (amount) => {
    const validated = /^[0-9\b]+$/;
    if (amount === "" || validated.test(amount)) {
      setAmount(amount);
      calculatePossibleGain(amount, teamId);
    }
  };

  const calculatePossibleGain = (amount, teamId) => {
    let odds = 0;
    if (teamId === matchData.team1) {
      odds = matchData?.moneyline?.home;
    } else if (teamId === matchData.team2) {
      odds = matchData?.moneyline?.away;
    } else if (teamId === "tie") {
      odds = matchData?.moneyline?.draw;
    }

    if (amount && odds) {
      setPossibleGain((amount * odds).toFixed(2));
    } else {
      setPossibleGain(0);
    }
  };

  useEffect(() => {
    calculatePossibleGain(amount, teamId);
  }, [amount, teamId, matchData]);

  const handleTeamSelection = (selectedTeam) => {
    if (teamId === selectedTeam) {
      setTeamId(null);
      setAmount("");
      setPossibleGain(0);
    } else {
      setTeamId(selectedTeam);
    }
  };

  return (
      <>
        <div
            className="modal fade"
            id="betHere"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              />
              <div className="modal-body text-center">
                <h1>{matchData.sport_name}</h1>
                <p className="color_yellow">
                  {time &&
                      new Date(time).toISOString().slice(11, 19)}{" "}
                  {time && "hrs left"}
                </p>
                <div className="match_detail">
                  <div className="team_content">
                    <div className="team_box">
                      <div
                          className={`team_logo team_logo_border ${
                              matchData.team1 === teamId ? "active" : ""
                          }`}
                          onClick={() => handleTeamSelection(matchData.team1)}
                      >
                        <img src={matchData.team1_logo || "/images/team.png"} className="team_logo" alt="team1" onError={(e) => { e.target.onerror = null; e.target.src = "/images/team.png"; }} />
                      </div>
                      <h5
                          className={`${
                              matchData.team1 === teamId ? "active" : ""
                          }`}
                      >
                        {matchData.team1display}
                      </h5>
                      <p>League</p>
                    </div>
                    <div className="match_timing team_box text-center">
                      <p className="textGRY700 textspaceAdd">
                        {moment(matchData.start_date).format("DD MMM  YYYY")}
                      </p>
                      <p className="text20black">
                        {moment(matchData.start_date).format("LT")}
                      </p>
                    </div>
                    <div className="team_box">
                      <div
                          className={`team_logo team_logo_border ${
                              matchData.team2 === teamId ? "active" : ""
                          }`}
                          onClick={() => handleTeamSelection(matchData.team2)}
                      >
                        <img src={matchData.team2_logo || "/images/team.png"} className="team_logo" alt="team2" onError={(e) => { e.target.onerror = null; e.target.src = "/images/team.png"; }} />
                      </div>
                      <h5
                          className={`${
                              matchData.team2 === teamId ? "active" : ""
                          }`}
                      >
                        {matchData.team2display}
                      </h5>
                      <p>{matchData.league_name}</p>
                    </div>
                  </div>
                  <div className="match_contest">
                    <div className="contect_detail">
                      <p className="P_gry_normal">Home</p>
                      <p className="H5_bold_black">
                        {matchData?.moneyline?.home}
                      </p>
                    </div>
                    <div className="contect_detail">
                      <p className="P_gry_normal">Tie</p>
                      <p className="H5_bold_black">
                        {matchData?.moneyline?.draw}
                      </p>
                    </div>
                    <div className="contect_detail">
                      <p className="P_gry_normal">Away</p>
                      <p className="H5_bold_black">
                        {matchData?.moneyline?.away}
                      </p>
                    </div>
                  </div>
                  <div className="bet_btns match_contest">
                    <div
                        className={`btn post_btn btnFill bet_btn`}
                        onClick={() => handleTeamSelection(matchData.team1)}>
                      <div className="btnfilltext">
                        {matchData.team1 === teamId ? "Cancel" : "BET"}
                      </div>
                    </div>
                    <div
                        className={`btn post_btn btnFill bet_btn`}
                        onClick={() => handleTeamSelection("tie")}>
                      <div className="btnfilltext">
                        {teamId === "tie" ? "Cancel Tie" : "BET Tie"}
                      </div>
                    </div>
                    <div
                        className={`btn post_btn btnFill bet_btn`}
                        onClick={() => handleTeamSelection(matchData.team2)}>
                      <div className="btnfilltext">
                        {matchData.team2 === teamId ? "Cancel" : "BET"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bet_action text-center">
                  <div className="bet_amount">
                    <input
                        type="text"
                        className="input"
                        onChange={(e) => verifyAmount(e.target.value)}
                        value={amount}
                    />
                    <div
                        className="btn post_btn fly_btn"
                        onClick={() => userBetsGame(matchData.id)}
                    >
                      <div>
                        <img src="./images/fly.png" className="fly_img" />
                      </div>
                    </div>
                  </div>
                  <p className="text_normal mt-2">
                    Possible Gain:{" "}
                    <span className="text_green">{possibleGain}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default BetModel;
